import React from 'react';

import { ButtonSlideshow } from './ButtonSlideshow';

type Props = {
  errorMessage: string;
  onClose: () => void;
};

export const ErrorForm: React.FC<Props> = ({ errorMessage, onClose }) => {
  return (
    <form
      className='mb-0'
      onSubmit={(event) => {
        event.preventDefault();
        onClose();
      }}
    >
      <p className='fs-16 mb-2'>{errorMessage}</p>
      <ButtonSlideshow state={'error'}>
        <button type='submit' className='btn bg-black'>
          Close
        </button>
      </ButtonSlideshow>
    </form>
  );
};
